import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { mergeStyles, ResponsiveMode, Sticky, StickyPositionType, useResponsiveMode, } from '@fluentui/react';
import { SubmitButton } from '../../SubmitButton';
import { useThemeData } from '@msrceng/theme';
/**
  A prestyled footer with submission controls to make all of MSRC's forms look and feel the same.
 */
export const FormFooter = ({ disabled = false, submittingMessage, errorMessage, form, isSubmitting = false, sticky = true, }) => {
    const formFooterRef = useRef(null);
    const viewportWidth = useResponsiveMode(formFooterRef);
    const isViewportWidthMinLarge = viewportWidth >= ResponsiveMode.large;
    const applySticky = sticky && isViewportWidthMinLarge;
    const ComponentName = applySticky ? StickyFormFooter : SubmitButton;
    return (_jsx("div", Object.assign({ ref: formFooterRef }, { children: _jsx(ComponentName, Object.assign({}, { disabled, errorMessage, form, isSubmitting, submittingMessage })) })));
};
const StickyFormFooter = ({ disabled, errorMessage, form, isSubmitting, submittingMessage, }) => {
    var _a;
    const { semanticColors } = ((_a = useThemeData()) === null || _a === void 0 ? void 0 : _a.theme) || {};
    return (_jsx(Sticky, Object.assign({ stickyBackgroundColor: semanticColors === null || semanticColors === void 0 ? void 0 : semanticColors.bodyFrameBackground, stickyPosition: StickyPositionType.Footer, stickyClassName: mergeStyles({
            borderTop: `1px solid ${semanticColors === null || semanticColors === void 0 ? void 0 : semanticColors.bodyFrameDivider}`,
        }) }, { children: _jsx("div", Object.assign({ style: {
                // 800 width, but at medium sizes, shrink to 90% to preserve gutter
                width: 800,
                maxWidth: '90%',
                margin: '12px auto',
                borderRadius: '4px',
            } }, { children: _jsx(SubmitButton, Object.assign({}, {
                disabled,
                errorMessage,
                form,
                isSubmitting,
                submittingMessage,
            })) })) })));
};
